/**
 * Register global components here and use them as a plugin in your main Vue instance
 */

import Headline from "./components/shared/headline.vue";
import ProductTile from "./components/shared/product/productTile.vue";
import QuickShopModal from "./components/shared/product/quickShopModal/quickShopModal.vue";
import QuickShopModalUnregistered from "./components/shared/product/quickShopModalUnregistered/quickShopModalUnregistered.vue";
import ApplyModal from "./components/shared/modal/applyModal/applyModal.vue";
import Modal from "./components/shared/modal/modal.vue";
import Dropdown from "./components/shared/input/dropdown/dropdown.vue";
import DropdownCategories from "./components/shared/input/dropdownCategories/dropdownCategories.vue";
import MultiSelect from "./components/shared/input/multiSelect/multiSelect.vue";
import Quantity from "./components/shared/input/quantityInput/quantityInput.vue";
import QuantitySelector from "./components/shared/input/quantitySelector/quantitySelector.vue";
import ResultLimiter from "./components/shared/resultLimiter/resultLimiter.vue";
import Pagination from "./components/shared/pagination/pagination.vue";
import EmailWhenAvailableModal from "./components/shared/emailWhenAvailableModal/emailWhenAvailableModal.vue";
import EventRSVPModal from "./components/shared/eventsRSVPModal/eventsRSVPModal.vue";
import PromoModal from "./components/shared/promoModal/promoModal.vue";
import LandingModal from "./components/shared/landingModal/landingModal.vue";
import Loader from "./components/shared/loader/loader.vue";
import LoaderStatic from "./components/shared/loader/loaderStatic.vue";
import HotList from "./components/shared/product/hotListCollection/hotList.vue";
import Accordion from "./components/shared/accordion/accordion.vue";
import Tabs from "./components/shared/tabs/tabs.vue";
import CategoryGrid from "./components/shared/categoryGrid/categoryGrid.vue";
import Options from "./components/shared/input/options/options.vue";
import Favorite from "./components/shared/favorite/favorite.vue";
import Notify from "./components/shared/notify/notify.vue";
import AlgoliaAutocomplete from "./components/shared/algoliaAutocomplete/algoliaAutocomplete.vue";
import ChatButton from "./components/shared/chatButton/chatButton.vue";
import ExpandableTableRow from "./components/ordersRetailerTable/expandableTableRow.js";
import AlgoliaInfiniteList from "./components/shared/algoliaInfiniteList/algoliaInfiniteList.vue";
import ImageWithFallback from "./components/shared/imageWithFallback/imageWithFallback.vue";
import Button from "./components/shared/button/button.vue";
import OpenNewTabButton from "./components/shared/button/open-new-tab-button/openNewTabButton.vue";
import BrandValueIcon from "./components/shared/brandValueIcon/brandValueIcon.vue";
import Checkbox from "./components/shared/checkbox/checkbox.vue";
import EntityImage from "./components/shared/entityImage/entityImage.vue";
import Chip from "./components/shared/chip/chip.vue";
import ErrorMessage from "./components/shared/errorMessage/errorMessage.vue";
import Badge from "./components/shared/badge/badge.vue";
import VideoPlayer from "./components/shared/video/video.vue";
import ProductSearchContainer from "./components/shared/productSearchContainer/productSearchContainer.vue";
import Toggle from "./components/shared/toggle/toggle.vue";
import AddImage from "./components/shared/addImage/addImage.vue";
import BrandSelector from "./components/shared/input/brandSelector/brandSelector.vue";
import ProductVariantBox from "./components/shared/productEditor/productVariantBox/productVariantBox.vue";
import RetailerSelector from "./components/shared/input/retailerSelector/retailerSelector.vue";
import CreditCardSelector from "./components/shared/input/creditCardSelector/creditCardSelector.vue";
import BulletinButton from "./components/shared/button/bulletin-button.vue";
import VariantPicker from "./components/shared/variantPicker/variantPicker.vue";
import AddressView from "./components/shared/addressView/addressView.vue";
import ProductCartSummary from "./components/shared/productCartSummary/productCartSummary.vue";
import BrandValues from "./components/shared/product/brandValues/brandValues.vue";
import TextField from "./components/shared/input/textField/textField";
import AddressAutocomplete from "./components/shared/input/addressAutocomplete/addressAutocomplete";
import AddressForm from "./components/shared/addressForm/addressForm";
import Heading4 from "@/components/shared/typography/heading4";
import VariantCharacteristicList from "./components/shared/variantCharacteristicList/variantCharacteristicList";
import FilterAccordion from "./components/shared/filters/filterAccordion";
import FilterPanel from "./components/shared/filters/filterPanel";
import CheckboxNew from "./components/shared/checkboxNew/checkboxNew";
import FilterRadioButton from "./components/shared/filters/filterRadioButton";
import FilterSearchInput from "./components/shared/filters/filterSearchInput";
import FilterBrandValuesNew from "./components/shared/filters/filterTypes/filterBrandValues";
import FilterBrandNew from "./components/shared/filters/filterTypes/filterBrand";
import FilterCategoriesNew from "./components/shared/filters/filterTypes/filterCategories";
import FilterDateNew from "./components/shared/filters/filterTypes/filterDate";
import FilterPriceNew from "./components/shared/filters/filterTypes/filterPrice";
import FilterMinimumOrderValueNew from "./components/shared/filters/filterTypes/filterMinimumOrderValue";
import FilterLocations from "./components/shared/filters/filterTypes/filterLocations";
import FilterBadges from "./components/shared/filters/filterBadges";
import SortingOptions from "./components/shared/filters/sortingOptions";
import MobileFilterHeader from "./components/shared/filters/mobileFilterHeader";
import MobileFilterPanel from "./components/shared/filters/mobileFilterPanel";
import ProductTiles from "./components/shared/productTiles/productTiles";

const SharedComponents = {
  install(Vue) {
    Vue.component("Accordion", Accordion);
    Vue.component("Headline", Headline);
    Vue.component("ProductTile", ProductTile);
    Vue.component("QuickShopModal", QuickShopModal);
    Vue.component("QuickShopModalUnregistered", ApplyModal);
    Vue.component("ApplyModal", QuickShopModalUnregistered);
    Vue.component("Modal", Modal);
    Vue.component("Dropdown", Dropdown);
    Vue.component("MultiSelect", MultiSelect);
    Vue.component("DropdownCategories", DropdownCategories);
    Vue.component("Quantity", Quantity);
    Vue.component("QuantitySelector", QuantitySelector);
    Vue.component("ResultLimiter", ResultLimiter);
    Vue.component("Pagination", Pagination);
    Vue.component("EmailWhenAvailableModal", EmailWhenAvailableModal);
    Vue.component("EventRsvpModal", EventRSVPModal);
    Vue.component("PromoModal", PromoModal);
    Vue.component("LandingModal", LandingModal);
    Vue.component("HotList", HotList);
    Vue.component("Loader", Loader);
    Vue.component("LoaderStatic", LoaderStatic);
    Vue.component("Tabs", Tabs);
    Vue.component("CategoryGrid", CategoryGrid);
    Vue.component("Options", Options);
    Vue.component("Favorite", Favorite);
    Vue.component("Notify", Notify);
    Vue.component("AlgoliaAutocomplete", AlgoliaAutocomplete);
    Vue.component("ChatButton", ChatButton);
    Vue.component("ExpandableTableRow", ExpandableTableRow);
    Vue.component("AlgoliaInfiniteList", AlgoliaInfiniteList);
    Vue.component("ImageWithFallback", ImageWithFallback);
    Vue.component("Btn", Button);
    Vue.component("OpenNewTabButton", OpenNewTabButton);
    Vue.component("BrandValueIcon", BrandValueIcon);
    Vue.component("Checkbox", Checkbox);
    Vue.component("EntityImage", EntityImage);
    Vue.component("Chip", Chip);
    Vue.component("ErrorMessage", ErrorMessage);
    Vue.component("Badge", Badge);
    Vue.component("VideoPlayer", VideoPlayer);
    Vue.component("Toggle", Toggle);
    Vue.component("ProductSearchContainer", ProductSearchContainer);
    Vue.component("AddImage", AddImage);
    Vue.component("BrandSelector", BrandSelector);
    Vue.component("ProductVariantBox", ProductVariantBox);
    Vue.component("RetailerSelector", RetailerSelector);
    Vue.component("BulletinButton", BulletinButton);
    Vue.component("CreditCardSelector", CreditCardSelector);
    Vue.component("VariantPicker", VariantPicker);
    Vue.component("AddressView", AddressView);
    Vue.component("ProductCartSummary", ProductCartSummary);
    Vue.component("BrandValues", BrandValues);
    Vue.component("TextField", TextField);
    Vue.component("AddressAutocomplete", AddressAutocomplete);
    Vue.component("AddressForm", AddressForm);
    Vue.component("Heading4", Heading4);
    Vue.component("VariantCharacteristicList", VariantCharacteristicList);
    Vue.component("FilterAccordion", FilterAccordion);
    Vue.component("FilterPanel", FilterPanel);
    Vue.component("CheckboxNew", CheckboxNew);
    Vue.component("FilterRadioButton", FilterRadioButton);
    Vue.component("FilterSearchInput", FilterSearchInput);
    Vue.component("FilterBrandValues", FilterBrandValuesNew);
    Vue.component("FilterBrandNew", FilterBrandNew);
    Vue.component("FilterCategoriesNew", FilterCategoriesNew);
    Vue.component("FilterDateNew", FilterDateNew);
    Vue.component("FilterPriceNew", FilterPriceNew);
    Vue.component("FilterMinimumOrderValueNew", FilterMinimumOrderValueNew);
    Vue.component("FilterLocations", FilterLocations);
    Vue.component("FilterBadges", FilterBadges);
    Vue.component("SortingOptions", SortingOptions);
    Vue.component("MobileFilterHeader", MobileFilterHeader);
    Vue.component("MobileFilterPanel", MobileFilterPanel);
    Vue.component("ProductTiles", ProductTiles);
  },
};

export default SharedComponents;
